import { useState, useEffect } from 'react';
import Highlight from '../autocomplete/highlight';
import { ListWithTitles } from './types';

import styles from './autocomplete-with-titles.module.css';

interface UseFilteredListProps {
  searchQuery: string;
  list: ListWithTitles[];
}

export default function useFilteredList({
  list,
  searchQuery,
}: UseFilteredListProps): ListWithTitles[] {
  const [filteteredList, setFilteteredList] = useState<ListWithTitles[]>([]);

  useEffect(() => {
    if (!searchQuery?.length) {
      setFilteteredList(list);
    } else {
      const filteredListItems: ListWithTitles[] = [];

      list.forEach((item) => {
        const filtered = item.list
          .filter((listItem) =>
            listItem.name.toLowerCase().includes(searchQuery.toLowerCase()),
          )
          .map((listItem) => {
            const result = {
              ...listItem,
              highlight: (
                <Highlight
                  searchQuery={searchQuery}
                  text={listItem.name}
                  className={styles.highlighted}
                />
              ),
            };

            return result;
          });

        if (
          filtered.length &&
          !filteredListItems.find((listItem) => listItem.title === item.title)
        ) {
          filteredListItems.push({
            title: item.title,
            list: filtered,
          });
        }
      });

      setFilteteredList(filteredListItems);
    }
  }, [list, searchQuery]);

  return filteteredList;
}
